import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Center, Spinner, Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { useGetCoolingInfoQuery } from "../../api/cooling";
import { PageHeader } from "../../components/shared/PageHeader";
import { CoolingPageContent } from "../../components/features/CoolingPage";

export const CoolingPage = () => {
  const navigate = useNavigate();
  const { data, isPending } = useGetCoolingInfoQuery();

  useEffect(() => {
    if (!isPending && !data?.isLimitCooldown) {
      navigate(RoutesMap.index);
    }
  }, [data?.isLimitCooldown, isPending]);

  if (isPending) {
    return (
      <Center h="100svh">
        <Spinner />
      </Center>
    );
  }

  if (!data?.isLimitCooldown) {
    return null;
  }

  return (
    <Stack spacing={0} minH="100svh" w="100%" alignItems="center">
      <PageHeader title="Подтверждение договора" />

      <CoolingPageContent limitInfo={data.limitInfo} />
    </Stack>
  );
};
